<template>
  <div class="zain-sidebar-style h-100">
    <div class="sidebar-content pt-4">
      <router-link :to="{ name: 'Home' }" class="sidebar-item ripple">
        <i class="la la-home"></i>
        <span>الرئيسية</span>
      </router-link>

      <router-link :to="{ name: 'Categories' }" class="sidebar-item ripple">
        <i class="la la-table"></i>
        <span>اكتشف</span>
      </router-link>

      <router-link :to="{ name: 'Authors' }" class="sidebar-item ripple">
        <i class="la la-microphone"></i>
        <span>المتحدثون</span>
      </router-link>

      <router-link :to="{ name: 'Favorite' }" class="sidebar-item ripple">
        <i class="la la-heart-o"></i>
        <span>المفضلة</span>
      </router-link>

      <router-link :to="{ name: 'Profile' }" class="sidebar-item ripple">
        <i class="la la-user-circle"></i>
        <span>حسابي</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>


<style scoped>
.zain-sidebar-style {
  background-color: #b91629;
  border-left: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}

.sidebar-item {
  display: flex;
  align-items: center;
  padding: 15px 25px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: all 0.2s;
  margin: 5px 15px;
  border-radius: 12px;
}

.sidebar-item i {
  font-size: 1.5rem;
  margin-left: 15px;
}

.sidebar-item span {
  font-size: 1.1rem;
  font-weight: 500;
}

.router-link-active {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff !important;
}

.sidebar-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
}
</style>